import { Option } from 'monapt'

const hasSpendAccountLockedCode = (graphQLErrors: any[]) =>
  graphQLErrors.some((graphQLError) => {
    return graphQLError.code === 'spend_account_locked'
  })

export const isSpendCardLocked = (spendAccountStatus: any): boolean => {
  const graphQLErrors = Option(spendAccountStatus)
    .flatMap((data) => Option(data.error))
    .flatMap((error) => Option(error.graphQLErrors))
    .getOrElse(() => [])

  return hasSpendAccountLockedCode(graphQLErrors)
}
